<!-- ── Боковое меню ───────────────────────────────────────────────────── -->
<aside class="ps-side" [class.open]="menuOpen" [attr.aria-label]="t('platform.menu', 'Меню')">
  <div class="ps-side__head">
    <a routerLink="/" class="ps-logo" [title]="t('platform.toSite', 'На сайт')">
      <img src="assets/logo.png" alt="Bilload" />
    </a>

    <!-- Телефон: язык — в меню рядом с логотипом (в верхней панели он скрыт) -->
    <div class="ps-lang ps-lang--side">
      <button type="button" class="ps-lang__btn" (click)="sideLangOpen = !sideLangOpen" [attr.aria-expanded]="sideLangOpen">
        {{ languageLabel }}
        <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
      </button>
      <div class="ps-lang__menu" *ngIf="sideLangOpen">
        <button type="button" *ngFor="let l of languages" [class.active]="l.code === currentLanguage" (click)="setLanguage(l.code)">{{ l.label }}</button>
      </div>
    </div>
  </div>

  <ng-template #navIcon let-icon>
      <span class="ps-nav__ic" aria-hidden="true" [ngSwitch]="icon">
        <svg *ngSwitchCase="'users'" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.6-3.6 3.3-5.5 6.5-5.5s5.9 1.9 6.5 5.5"/><path d="M15.5 4.8a3.5 3.5 0 0 1 0 6.4M18 14.8c2 .7 3.2 2.4 3.5 5.2"/></svg>
        <svg *ngSwitchCase="'chart'" viewBox="0 0 24 24"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></svg>
        <svg *ngSwitchCase="'search'" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>
        <svg *ngSwitchCase="'bids'" viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>
        <svg *ngSwitchCase="'deals'" viewBox="0 0 24 24"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></svg>
        <svg *ngSwitchCase="'payments'" viewBox="0 0 24 24"><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3z"/><path d="M9 8h6M9 12h6"/></svg>
        <svg *ngSwitchCase="'invoice'" viewBox="0 0 24 24"><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5M10 13h6M10 17h6"/></svg>
        <svg *ngSwitchCase="'freight'" viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>
        <svg *ngSwitchCase="'permits'" viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>
        <svg *ngSwitchCase="'overview'" viewBox="0 0 24 24"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h8M8 12h2M14 12h2M8 16h2M14 16h2"/></svg>
        <svg *ngSwitchCase="'supplier'" viewBox="0 0 24 24"><path d="M3 21V10l5 3V10l5 3V6l8 4v11z"/><path d="M3 21h18M8 17h2M14 17h2"/></svg>
        <svg *ngSwitchCase="'transport'" viewBox="0 0 24 24"><path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4M12 11v10"/></svg>
        <svg *ngSwitchCase="'plus'" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></svg>
        <svg *ngSwitchCase="'list'" viewBox="0 0 24 24"><path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="18" r="1"/></svg>
      </span>
  </ng-template>

  <nav class="ps-nav">
    <ng-container *ngFor="let item of mainNav">
      <a *ngIf="!item.locked; else lockedItem" class="ps-nav__item" [routerLink]="item.route" [class.active]="isActive(item)" [class.ps-nav__item--divider]="item.divider">
        <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: item.icon }"></ng-container>
        {{ t(item.labelKey, item.fallback) }}
      </a>
      <!-- Гость: раздел откроется после ввода телефона -->
      <ng-template #lockedItem>
        <button type="button" class="ps-nav__item ps-nav__item--locked" [class.ps-nav__item--divider]="item.divider"
                [title]="t('phoneClaim.locked', 'Откроется после ввода телефона')" (click)="openLocked(item)">
          <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: item.icon }"></ng-container>
          <span class="ps-nav__label">{{ t(item.labelKey, item.fallback) }}</span>
          <svg class="ps-nav__lock" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
        </button>
      </ng-template>
    </ng-container>
  </nav>

  <!-- Главное действие — отдельной кнопкой внизу меню -->
  <div class="ps-cta" *ngIf="ctaNav.length">
    <a *ngFor="let item of ctaNav" class="ps-cta__btn" [routerLink]="item.route" [class.active]="isActive(item)" (click)="menuOpen = false">
      <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: item.icon }"></ng-container>
      {{ t(item.labelKey, item.fallback) }}
    </a>
  </div>

  <!-- Телефон: курсы валют в меню (в верхней панели им не хватает места) -->
  <app-currency-rates class="ps-rates ps-rates--side" variant="dark"></app-currency-rates>

  <div class="ps-side__bottom">
    <a routerLink="/" class="ps-nav__item ps-nav__item--muted">
      <span class="ps-nav__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 11l9-7 9 7M5 9.5V20h14V9.5"/></svg></span>
      {{ t('platform.toSite', 'На сайт') }}
    </a>
    <button type="button" class="ps-nav__item ps-nav__item--muted" (click)="logout()">
      <span class="ps-nav__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4M10 16l4-4-4-4M14 12H3"/></svg></span>
      {{ t('platform.logout', 'Выйти') }}
    </button>
  </div>
</aside>

<div class="ps-backdrop" *ngIf="menuOpen" (click)="menuOpen = false"></div>

<!-- ── Верхняя панель рабочей области ─────────────────────────────────── -->
<header class="ps-top">
  <button type="button" class="ps-burger" (click)="menuOpen = !menuOpen" [attr.aria-expanded]="menuOpen" [attr.aria-label]="t('platform.menu', 'Меню')">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
  </button>
  <a routerLink="/" class="ps-top__home" [title]="t('platform.toSite', 'На сайт')"><img class="ps-top__logo" src="assets/logo.png" alt="Bilload" /></a>

  <div class="ps-top__actions">
    <app-currency-rates class="ps-rates ps-rates--top"></app-currency-rates>

    <div class="ps-lang ps-lang--top">
      <button type="button" class="ps-lang__btn" (click)="langOpen = !langOpen" [attr.aria-expanded]="langOpen">
        {{ languageLabel }}
        <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
      </button>
      <div class="ps-lang__menu" *ngIf="langOpen">
        <button type="button" *ngFor="let l of languages" [class.active]="l.code === currentLanguage" (click)="setLanguage(l.code)">{{ l.label }}</button>
      </div>
    </div>

    <app-notification-bell></app-notification-bell>

    <a routerLink="/profile" class="ps-user" [title]="user?.fullName || ''">
      <span class="ps-user__avatar">{{ initials }}</span>
      <span class="ps-user__text">
        <strong>{{ user?.fullName }}</strong>
        <small>{{ user?.role?.name }}</small>
      </span>
    </a>
  </div>
</header>
